import { render, staticRenderFns } from "./CollarLeashProductStyles.vue?vue&type=template&id=937a75ba&scoped=true&"
import script from "./CollarLeashProductStyles.vue?vue&type=script&lang=js&"
export * from "./CollarLeashProductStyles.vue?vue&type=script&lang=js&"
import style0 from "./CollarLeashProductStyles.vue?vue&type=style&index=0&id=937a75ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937a75ba",
  null
  
)

export default component.exports